import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { logout, validateToken } from '@/features/auth/authentication';
import Nav from '@/features/auth/nav.component';
import AppLayout from '@/shared/components/layout/app-layout.component';
import { getStoredToken } from '@/shared/services/session.service';

export const Route = createFileRoute('/_authenticated')({
  component: () => (
    <AppLayout nav={<Nav />}>
      <Outlet />
    </AppLayout>
  ),
  beforeLoad: () => {
    const token = getStoredToken();

    if (token === null) {
      throw redirect({ to: '/login' });
    }

    try {
      validateToken(token);
    } catch {
      logout();
      throw redirect({ to: '/login' });
    }
  },
});
